<div class="item">
    <p
        class="text theme-text rounded-full"
        [attr.data-text]="textColor()"
        [attr.data-background]="backgroundColor()"
        [attr.data-disabled]="disabled()"
    >
        {{ day().format("DD") }}
    </p>
</div>
